module.exports = __webpack_public_path__ + "img/iso-dinapsis.06362087.svg";